// extracted by mini-css-extract-plugin
export default {"container":"Form_container__ggr4b","text":"Form_text__OVUvT","form":"Form_form__ELFuR","containerForm":"Form_containerForm__2aP5i","button":"Form_button__JsfO1"};